exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".o-bb-nav {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  list-style-type: none;\n  margin: 0;\n  min-height: 40px; }\n  .bb-panel .o-bb-nav {\n    background-color: #000; }\n  .o-bb-modal .o-bb-nav {\n    padding: 10px 0 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/@browsbox-ui/bb-nav/nav.scss
// module id = 1909
// module chunks = 0